import { render } from "./FloatingChatWidget.vue?vue&type=template&id=4bc815e6"
import script from "./FloatingChatWidget.vue?vue&type=script&lang=js"
export * from "./FloatingChatWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/FloatingChatWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bc815e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bc815e6', __exports__)) {
    console.log('reload')
    api.reload('4bc815e6', __exports__)
  }
  
  module.hot.accept("./FloatingChatWidget.vue?vue&type=template&id=4bc815e6", () => {
    console.log('re-render')
    api.rerender('4bc815e6', render)
  })

}


export default __exports__